import React from "react";
import { TestimonialCarousel } from "@trussle/external-components";
import { PanelWrapper } from "../../PanelWrapper";

import "./style.scss";

export interface ITrustPilotPanelProps {
  customerReviewsContent: ICustomerReviewsObject;
}

type ICustomerReviewsObject = {
  reviews: {
    author: string;
    text: string;
    productType: "Mortgage" | "Remortgage" | "Insurance";
    rating: number;
  }[]
}

export const TrustpilotWithReviewsPanel: React.FC<ITrustPilotPanelProps> = ({
  customerReviewsContent,
}) => {
  if (!customerReviewsContent) {
    return null;
  }

  return (
    <PanelWrapper backgroundColour="light-yellow" className="trustpilot-with-reviews-panel" isBetterV2>
      <TestimonialCarousel
        cards={customerReviewsContent.reviews}
        classOverrides={{ reviewsContainer: "carousel-overrides" }}
      />
    </PanelWrapper>
  );
};
